import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  taskData: {},
  pageFlag: 'create'
}

export const taskSlice = createSlice({
  name: 'task',
  initialState,
  reducers: {
    // 自动生成 action creator 和 reducer
    setTaskDataAction: (state, action) => {
      state.taskData = action.payload
    },
    setTaskPageFlagAction: (state, action) => {
      state.pageFlag = action.payload
    },
  }
})

// 自动生成的 action creators
export const { setTaskDataAction, setTaskPageFlagAction } = taskSlice.actions

// Selectors
export const selectTaskData = (state) => state.task.taskData
export const selectTaskPageFlag = (state) => state.task.pageFlag

// Reducer
export default taskSlice.reducer